import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { BLANK_CTA, BLANK_SECONDARY_CTA } from '../../complete-node.constants';
import type { CompleteFormData, CompleteSection, CtaSlot, PreviewSelection } from '../../complete-node.types';
const ALL_OPEN: Record<CompleteSection, boolean> = {
  basic: true,
  buttons: true,
  autoAdvance: true
};
const SECTION_OF: Record<PreviewSelection, CompleteSection> = {
  header: 'basic',
  content: 'basic',
  primary: 'buttons',
  secondary: 'buttons'
};
export const usePanelState = (form, t0) => {
  const $ = _c(16);
  const initialSelection = t0 === undefined ? null : t0;
  const [openSections, setOpenSections] = useState(ALL_OPEN);
  const [selected, setSelected] = useState(initialSelection);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (section, open) => setOpenSections(current => ({
      ...current,
      [section]: open
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const setSectionOpen = t1;
  let t2;
  if ($[1] !== form || $[2] !== selected) {
    t2 = item => {
      if (selected === item) {
        setSelected(null);
        return;
      }
      setSelected(item);
      setSectionOpen(SECTION_OF[item], true);
      if (item === "header" || item === "content") {
        setTimeout(() => form.setFocus(item), 0);
      }
    };
    $[1] = form;
    $[2] = selected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectFromPreview = t2;
  let t3;
  if ($[4] !== form) {
    t3 = () => {
      form.setValue("ctaCount", form.getValues("ctaCount") > 0 ? 2 : 1, {
        shouldDirty: true
      });
      setSectionOpen("buttons", true);
    };
    $[4] = form;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const addCta = t3;
  let t4;
  if ($[6] !== form || $[7] !== selected) {
    t4 = slot => {
      if (selected === slot) {
        setSelected(null);
      }
      if (slot === "primary") {
        form.setValue("ctaCount", 0, {
          shouldDirty: true
        });
        form.setValue("ctaLabel", BLANK_CTA.ctaLabel, {
          shouldDirty: true
        });
        form.setValue("ctaUrl", BLANK_CTA.ctaUrl, {
          shouldDirty: true
        });
        form.setValue("ctaTarget", BLANK_CTA.ctaTarget, {
          shouldDirty: true
        });
        form.clearErrors(["ctaLabel", "ctaUrl"]);
        return;
      }
      form.setValue("ctaCount", 1, {
        shouldDirty: true
      });
      form.setValue("secondaryCtaLabel", BLANK_SECONDARY_CTA.secondaryCtaLabel, {
        shouldDirty: true
      });
      form.setValue("secondaryCtaUrl", BLANK_SECONDARY_CTA.secondaryCtaUrl, {
        shouldDirty: true
      });
      form.setValue("secondaryCtaTarget", BLANK_SECONDARY_CTA.secondaryCtaTarget, {
        shouldDirty: true
      });
      form.setValue("secondaryCtaStyle", BLANK_SECONDARY_CTA.secondaryCtaStyle, {
        shouldDirty: true
      });
      form.clearErrors(["secondaryCtaLabel", "secondaryCtaUrl"]);
    };
    $[6] = form;
    $[7] = selected;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const removeCta = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpenSections(ALL_OPEN);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const openAllSections = t5;
  let t6;
  if ($[10] !== addCta || $[11] !== openSections || $[12] !== removeCta || $[13] !== selectFromPreview || $[14] !== selected) {
    t6 = {
      openSections,
      setSectionOpen,
      selected,
      selectFromPreview,
      addCta,
      removeCta,
      openAllSections
    };
    $[10] = addCta;
    $[11] = openSections;
    $[12] = removeCta;
    $[13] = selectFromPreview;
    $[14] = selected;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export type PanelState = ReturnType<typeof usePanelState>;